module.exports = __webpack_public_path__ + "img/Language switch screen.187463bb.png";